import React, { useEffect } from "react";
import { Button, Menu, MenuItem } from "@mui/material";
import UnfoldMoreIcon from "@mui/icons-material/UnfoldMore";
import { useLanguageContext } from "../../../Context/LanguageContext";
import {
  useEquipmentStatusActionsContext,
  useItemSelectedFilterContext,
} from "../../../Context/GridEquipListContext";

export default function DropDownButton({
  reportCode,
  handleDropChange,
  state,
  setState,
}) {
  // const [state, setState] = React.useState(
  //   reportCode === "EquipList" ? "All" : "Last 30 days"
  // );
  const updateEquipmentStatus = useEquipmentStatusActionsContext();

  const [stateAnchorEl, setStateAnchorEl] = React.useState(null);
  const { localization } = useLanguageContext();
  const itemSelectedFilter = useItemSelectedFilterContext();
  const optionList1 = [
    { Name: localization.all, value: "All" },
    { Name: localization.active, value: "Active" },
    { Name: localization.inActive, value: "Inactive" },
  ];
  const optionList2 = [
    { Name: localization.last30, value: "Last 30 days" },
    { Name: localization.last60, value: "Last 2 month" },
    { Name: localization.all, value: "All" },
  ];
  const handleStateClick = (event) => {
    setStateAnchorEl(event.currentTarget);
  };

  const handleStateClose = (newState) => {
    if (newState) {
      updateEquipmentStatus(newState === "All" ? "" : newState);
      setState(newState);
      handleDropChange(newState, itemSelectedFilter);
    }
    setStateAnchorEl(null);
  };

  return (
    <>
      <Button
        variant="contained"
        className="gridTableButton gridTableButtonStyle"
        style={{ marginLeft: 8 }}
        onClick={handleStateClick}
        endIcon={<UnfoldMoreIcon />}
      >
        {reportCode === "EquipList"
          ? localization.Status + ":"
          : localization.timeFrame + ": "}
        {state == "Active"
          ? localization.active
          : state == "Inactive"
          ? localization.inActive
          : state == "Last 30 days"
          ? localization.last30
          : state == "Last 2 month"
          ? localization.last60
          : localization.all}
      </Button>
      <Menu
        anchorEl={stateAnchorEl}
        open={Boolean(stateAnchorEl)}
        onClose={() => handleStateClose(null)}
      >
        {reportCode === "EquipList"
          ? optionList1.map((item, index) => (
              <MenuItem
                key={index}
                style={{ fontSize: "16px" }}
                onClick={() => handleStateClose(item.value)}
              >
                {item.Name}
              </MenuItem>
            ))
          : optionList2.map((item, index) => (
              <MenuItem
                key={index}
                style={{ fontSize: "16px" }}
                onClick={() => handleStateClose(item.value)}
              >
                {item.Name}
              </MenuItem>
            ))}
      </Menu>
    </>
  );
}
